module.exports = __webpack_public_path__ + "static/img/prod_pic12.1a12067.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prod_pic12.jpg
// module id = N4fk
// module chunks = 5